/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import ProjectStaggeredItems from 'components/ProjectStaggeredItems';
import { Action } from 'store/slices';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import AppStyle from 'scss/main/App.module.scss';
import { getSvgIcon } from 'resources';
import { AppStore24Filled, Play24Filled } from '@fluentui/react-icons';
import { RootState } from 'store/types';
import { InView } from 'react-intersection-observer';
import { getScrollPosition, getY, ProjectItemInterface, scrollGetY, setY } from 'utils/scrolling';

const Project: React.FC<{}> = () => {
  
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);

  const scrollY = useSelector((state: RootState) => state.ui.scrollY);

  const image1: any = useRef<HTMLInputElement>(null);
  const image2: any = useRef<HTMLInputElement>(null);
  const image3: any = useRef<HTMLInputElement>(null);
  const image4: any = useRef<HTMLInputElement>(null);

  var imageSet: number[] = new Array(4)

  const items: ProjectItemInterface[] = [
    {
      src: '744fae027e362cf5dd95ca0a7a0ac06d1d3517c99bb594f0bc62b0141bc31691.webp',
      title: 'ScoRex - Social & eCommerce Mobile Apps.',
      desc: 'ScoRex is a versatile Social & eCommerce Mobile Application template, perfectly tailored for aspiring entrepreneurs. Offering an Instagram-inspired UI/UX interaction, it seamlessly combines social communication features with powerful eCommerce capabilities. Shop owners can effortlessly sell and manage their products, making it an ideal platform for startups looking to engage their audience and boost their online business presence.',
      ref: image1
    },
    {
      src: '32850baf4bfe5a93b733f4a057caf160609ba2594b3d827ad2bffe23d4fb6fce.webp',
      title: 'Sland  - FinTech, Securities & Futures information demo mobile apps.',
      desc: 'Sland is a cutting-edge FinTech, Securities & Futures information demo mobile app template, purpose-built to cater to the needs of FinTech businesses. With its user-friendly UI/UX design, Sland offers a seamless experience for accessing complex Securities & Futures data. It simplifies the intricate world of financial information, making it easily understandable and accessible, making it an invaluable tool for FinTech startups seeking to provide comprehensive data solutions to their clients.',
      ref: image2
    },
    {
      src: '42e088ae38951ff131bdfbe41278be400ba0ed2907a4fdea1d0aee8b93dd362b.webp' ,
      title: 'Lons - FinTech & Forex information mobile apps.',
      desc: 'Lons is the ultimate solution for budding FinTech enterprises, offering a user-friendly mobile app template focused on Forex and cryptocurrency data. With its intuitive UI/UX design, Lons simplifies complex financial information, providing an easily understandable interface for users. This template is the ideal choice for FinTech startups looking to deliver comprehensive Forex and crypto data services, ensuring a seamless and accessible experience for their clients.',
      ref: image3
    },
    {
      src: 'a0bc872b2d91e0c29ba06f285ee174897105b745b19071f2fb1bce1f7ab77e51.webp',
      title: 'Scrummy - Social, Forum and sharing mobile apps.',
      desc: `Scrummy is the ultimate mobile app template for social interaction, forums, and content sharing. With a user-friendly design that simplifies the forum experience, Scrummy offers a Reddit-like platform with a twist – unmatched clarity, and the best user experience. It's the go-to choice for those seeking an easily navigable, informative, and engaging space for discussions and content sharing, making it the perfect solution for your project's needs.`,
      ref: image4
    }
  ]

  for (var i = 0; i < 4; i++) {
    imageSet[i] = (items[i].ref && items[i].ref.current && items[i].ref.current.offsetTop) || 0

    if (getY(`image${i + 1}Y`) !== imageSet[i] && imageSet[i] !== 0) {
      setY(`image${i + 1}Y`, imageSet[i])
    }
  }

  return (
    <div className={AppStyle['project']}>
      <div>
        <div style={{backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}2f22f3ea604d11ee8c990242ac120002.webp')`}}>
          <InView triggerOnce>
            {({ inView, ref }) => (
              <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div>Innovator</div>
                <div>One person, Countless<br />Technology Achievements:<br />UI/UX to Implementation.</div>
                <div>Experienced in diverse tech projects, adept in UI/UX design and proficient in solo implementation of concepts, delivering exceptional results.</div>
                <div>
                  <div>No. of listed application on App Store & Google Play</div>
                  <div>
                    <div>
                      <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'appstore'})}`}} />
                      <div>7+</div>
                    </div>
                    <div>
                      <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'googleplay'})}`}} />
                      <div>7+</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </InView>
        </div>
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div className={`${inView && AppStyle['descAnimI']}`} style={!inView ? { opacity: '0.0' } : {}} ref={ref}>
              <div className={tabIndex === 0 ? AppStyle['active'] : undefined} onClick={() => setTabIndex(0)}>App. Development Templates</div>
              <div className={tabIndex === 1 ? AppStyle['active'] : undefined} onClick={() => setTabIndex(1)}>App. Development Projects</div>
              <div className={tabIndex === 2 ? AppStyle['active'] : undefined} onClick={() => setTabIndex(2)}>Research Projects</div>
            </div>
          )}
        </InView>
        <div>
          {
            tabIndex === 0 ?
              items.map((d, i) => <InView triggerOnce>
              {({ inView, ref }) => (
                <div key={`key-${i}`} className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                  <div>
                    <div>0{(i + 1)}</div>
                  </div>
                  <div>
                    <div>{d.title}</div>
                    <div>{d.desc}</div>
                    <div>
                      <div onClick={() => navigate('/contact')}>Contact for more information for this template</div>
                    </div>
                  </div>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div ref={ref}>
                        <img src={process.env.REACT_APP_CDN_PATH + d.src} ref={d.ref} style={{ willChange: 'transform', transform: !inView ? 'translate3d(0px, -5%, 0px)' : `translate3d(0px, ${scrollGetY(getScrollPosition(), getY(`image${i + 1}Y`), 0.5)}%, 0px)` }} />
                      </div>
                    )}
                  </InView>
                </div>
              )}
            </InView>)
            : <noindex>
              <div>Coming Soon...</div>
            </noindex>
          }
        </div>
      </div>
    </div>
  )
}

export default Project